// extracted by mini-css-extract-plugin
export default {"featureContainer":"Features_featureContainer__QDBBR","cardsContainer":"Features_cardsContainer__7NsY2"};